import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import HttpsRedirect from 'react-https-redirect';
import 'antd/dist/antd.css';
import App from './App';
import CheckoutFormTwo from './CheckoutFormTwo';

const apiUrl = `https://api.textanoffer.com`;
// const apiUrl = 'http://localhost:7777';

const assetsUrl = `https://d3e1kkgyadh560.cloudfront.net`;
// const key = 'pk_test_51IAJtDCuH1JmFwY3ysAvuC5lSFVuzgBpg8ZpPapulCA5ef2fmGPvT2WivNpIRJlU7EYgmhG2wvPLgzgrAd73vyUn00bHyGDQ3k';
const key = 'pk_live_51IAJtDCuH1JmFwY37pxZEbBVCsbYVz9BUqCImzP1IXhyE4pLKZCtCAMQB4Y7nWDvOqnRQ7hWl8YOuBaZ4ngVqbgW00Z0o5xrcA';
// const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

const stripe = { key };
const subdomain = window.location.host.split('.')[1] ?
        window.location.host.split('.')[0] : false;
const Searchparams = window.location.search.substring(1) ? window.location.search : null ;
const params = new URLSearchParams(Searchparams)
const mid = params.get('mid')
  // const url = "https://embed.textanoffer.com"
  // const subdomain = 'embed'
  // const mid = '63b4237db8b5231fec88a624'

ReactDOM.render(
  <HttpsRedirect>
    <React.StrictMode>
     {subdomain !== 'embed' && <App assetsUrl={assetsUrl} apiUrl={apiUrl} Stripe={stripe} />}
     {subdomain === 'embed' && <CheckoutFormTwo merchant={mid} apiUrl={apiUrl}></CheckoutFormTwo>}
    {/* <BrowserRouter>
    <Switch>
      <Route path="/embed" component={()=><CheckoutFormTwo merchant={mid} apiUrl={apiUrl}></CheckoutFormTwo>}/>
    </Switch>
    </BrowserRouter> */}
    </React.StrictMode>



  </HttpsRedirect>,
  document.getElementById('root')
);